import { render, staticRenderFns } from "./HeroHeadlineElement.vue?vue&type=template&id=c2186e74&scoped=true&"
import script from "./HeroHeadlineElement.vue?vue&type=script&lang=ts&"
export * from "./HeroHeadlineElement.vue?vue&type=script&lang=ts&"
import style0 from "./HeroHeadlineElement.vue?vue&type=style&index=0&id=c2186e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2186e74",
  null
  
)

export default component.exports